var CommonScript = (function($){

    var Init = function() {
        // Anchor nav
        $('.anchor_link').on('click', function() {
            $.scrollTo($($(this).attr('href')), {
                axis: 'y',
                duration: 800,
                offset: {
                    'top': -120
                }
            });
        });
        // Progress bar
        $(".img-progress-bar img").on('load',function() {
            $('.img-progress-bar img').loadgo({
                'bgcolor': '#eaf1eb',
                'opacity': 0.7
            });
            var status = $(".img-progress-bar").data("status");
            var total = $(".img-progress-bar").data("total");
            var percent = status / total * 100;
            $('.img-progress-bar img').loadgo('setprogress', percent);
        }).each(function() {
            if (this.complete) $(this).load();
        });

        // FORM js-datepicker!
        $(document).on('cf.form.init', function (event, data) {
          $('.js-datepast').find('.form-control').each(function() {
            $(this).html('<option value="" disabled="" selected="">Selecciona l&apos;any</option>');
            var year = (new Date()).getFullYear();
            var current = year;
            //year -= 100;
            for (var i = 0; i < 100; i++) {
              $(this).append('<option value="' + (year - i) + '">' + (year - i) + '</option>');
            }
          });
          $('.js-datefuture').find('.form-control').each(function() {
            $(this).html('<option value="" disabled="" selected="">Selecciona l&apos;any</option>');
            var year = (new Date()).getFullYear();
            var current = year;
            year += 15;
            for (var i = 15; i > 0; i--) {
              $(this).append('<option value="' + (year - i) + '">' + (year - i) + '</option>');
            }
          });
          // DEPECRATED: Old datepicker
          $.fn.datepicker.language.ca = {
            days: ['Diumenge', 'Dilluns', 'Dimarts', 'Dimecres', 'Dijous', 'Divendres', 'Dissabte'],
            daysShort: ['dg', 'dl', 'dt', 'dc', 'dj', 'dv', 'ds'],
            daysMin: ['dg', 'dl', 'dt', 'dc', 'dj', 'dv', 'ds'],
            months: ['Gener','Febrer','Març','Abril','Maig','Juny', 'Juliol','Augost','Setembre','Octubre','Novembre','Decembre'],
            monthsShort: ['Gen', 'Feb', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dec'],
            today: 'Avui',
            clear: 'Clear',
            dateFormat: 'dd/mm/yyyy',
            timeFormat: 'hh:ii aa',
            firstDay: 1
          };
          $('.js-datepicker input').each(function(){
            $(this).datepicker({
                language: 'ca',
                maxDate: new Date()
            });
          });
          $('.js-datepicker-future input').each(function(){
            $(this).datepicker({
                language: 'ca',
                minDate: new Date()
            });
          });
        });

        $( document ).on('cf.add', function(event,data){
          var selector = $("#"+data.field);
          var year = (new Date()).getFullYear();
          var current = year;
          var i = 0;
          if(selector.parents('div').hasClass('js-datepast')){
            selector.html('<option value="" disabled="" selected="">Selecciona l&apos;any</option>');
            //year -= 80;
            for (i = 0; i < 100; i++) {
              selector.append('<option value="' + (year - i) + '">' + (year - i) + '</option>');
            }
          }
          if(selector.parents('div').hasClass('js-datefuture')){
            selector.html('<option value="" disabled="" selected="">Selecciona l&apos;any</option>');
            year += 15;
            for (i = 15; i > 0; i--) {
              selector.append('<option value="' + (year - i) + '">' + (year - i) + '</option>');
            }
          }
          // DEPRECATED: Old datepicker
          $('.js-datepicker input').each(function(){
            $(this).datepicker({
                language: 'ca',
                maxDate: new Date()
            });
          });
          $('.js-datepicker-future input').each(function(){
            $(this).datepicker({
                language: 'ca',
                minDate: new Date()
            });
          });
        });

        // Promo Codes auto
        // var promo_code = $('.main').data('promocode');
        // if (promo_code) {
        //     $('*[data-field-id="field50"]').val("2DYR37EY");
        //     $('*[data-field-id="field51"]').val("2DYR37EY");
        //     $('*[data-field-id="field50"]').attr("disabled", "disabled");
        //     $('*[data-field-id="field51"]').attr("disabled", "disabled");
        //     $('*[data-field-id="field50"]').hide();
        //     $('*[data-field-id="field51"]').hide();
        // }
    };

    // "public" methods
    return {
        Init : Init
    };
})(jQuery);
